var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinwt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.375 1.4825e-07H14.625C15.0682 -0.000131243 15.5072 0.0870761 15.9167 0.256639C16.3262 0.426202 16.6984 0.674798 17.0118 0.988222C17.3252 1.30165 17.5738 1.67376 17.7434 2.08329C17.9129 2.49282 18.0001 2.93175 18 3.375V14.625C18.0001 15.0682 17.9129 15.5072 17.7434 15.9167C17.5738 16.3262 17.3252 16.6984 17.0118 17.0118C16.6984 17.3252 16.3262 17.5738 15.9167 17.7434C15.5072 17.9129 15.0682 18.0001 14.625 18H3.375C2.93175 18.0001 2.49282 17.9129 2.08329 17.7434C1.67376 17.5738 1.30165 17.3252 0.988222 17.0118C0.674798 16.6984 0.426202 16.3262 0.256639 15.9167C0.0870761 15.5072 -0.000131243 15.0682 1.4825e-07 14.625V3.375C-0.000131243 2.93175 0.0870761 2.49282 0.256639 2.08329C0.426202 1.67376 0.674798 1.30165 0.988222 0.988222C1.30165 0.674798 1.67376 0.426202 2.08329 0.256639C2.49282 0.0870761 2.93175 -0.000131243 3.375 1.4825e-07ZM12.209 9C12.3778 9.00003 12.5444 8.96212 12.6965 8.88908C12.8487 8.81603 12.9825 8.70972 13.088 8.578L15.206 5.931C15.3668 5.74652 15.4512 5.50764 15.4419 5.26309C15.4326 5.01854 15.3303 4.78675 15.156 4.615C13.4818 3.0687 11.2789 2.22239 9 2.25C6.72087 2.22265 4.51775 3.0689 2.843 4.615C2.66881 4.78688 2.56676 5.01874 2.55765 5.26329C2.54854 5.50783 2.63308 5.74664 2.794 5.931L4.912 8.578C5.01752 8.70972 5.1513 8.81603 5.30345 8.88908C5.4556 8.96212 5.62223 9.00003 5.791 9H12.209Z",
    fill: "#FF3464"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.412 5.34992L10.5 8.99992H7.5L11.245 5.25492C11.2605 5.2398 11.2806 5.23013 11.3021 5.22737C11.3236 5.22462 11.3454 5.22892 11.3642 5.23964C11.3831 5.25036 11.3979 5.26691 11.4065 5.2868C11.4151 5.30669 11.4171 5.32884 11.412 5.34992Z",
    fill: "#FF3464"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinwt);
export default __webpack_public_path__ + "static/media/finwt.0d0793cc266c9a79516cfa1664912ce4.svg";
export { ForwardRef as ReactComponent };